import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import "../../assets/css/dashboard.css";
import { useNavigate } from "react-router-dom";
import { Avatar } from "primereact/avatar";
import { OverlayPanel } from "primereact/overlaypanel";
import { useSelector, useDispatch } from "react-redux";
import { persistStore } from "redux-persist";
import { store } from "../../store/store";
import { LOGOUT, PROJECT_PANEL, SAVE_DATE_RANGE } from "../../utils/constants";
import Cookies from "js-cookie";
import { useGlobalContext } from "../../context/GlobalContext";
import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";

const dateRangeOptions = [
  { range: "Past 13 weeks", value: 13 },
  { range: "Past 26 weeks", value: 26 },
  { range: "Past 39 weeks", value: 39 },
  { range: "Past 52 weeks", value: 52 },
];

const Header = ({
  handleShowSidebar,
  showSidebar,
  setSelectedPanelProject,
  selectePanelProject,
  subHeaderText,
}) => {
  const { clearContext } = useGlobalContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { filter_week, end_date } = useSelector((state) => state.dateRange);
  const op = useRef(null);
  const [showChangePwdModal, setShowChangePwdModal] = useState(false);

  const handleButtonClick = (buttonLabel) => {
    if (buttonLabel === "DASHBOARD") {
      navigate("/dashboard");
    } else if (buttonLabel === "REPORTS") {
      navigate("/reports");
    }
  };

  const handleDropdownClick = (option) => {
    if (option.value === "logout") {
      logout();
    } else {
      navigate(`/${option.value}`);
    }
  };

  const logout = () => {
    dispatch({ type: LOGOUT });
    clearContext();
    // Ensure persist store is cleared
    persistStore(store)
      .purge()
      .then(() => {
        localStorage.clear(); // Extra safety to clear local storage
        sessionStorage.clear();
        // Clear all cookies (this removes all cookies for the current domain)
        document.cookie.split(";").forEach((cookie) => {
          const eqPos = cookie.indexOf("=");
          const name =
            eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
          // Set cookie expiry to past date to delete it
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });
        navigate("/login"); // Redirect to login page after logout
      });
  };

  return (
    <>
      {/* Top Header */}
      <div
        className={`d-flex align-items-center p-3 border-bottom position-fixed top-header justify-content-between ${!showSidebar ? "hide-sidebar" : ""}`}
      >
        <div className="text-start d-flex align-items-center justify-content-between">
          <div
            className="text-start hide-sidebar-icon d-flex align-items-center justify-content-center"
            onClick={handleShowSidebar}
          >
            <i
              className={`pi ${!showSidebar ? "pi-angle-right" : "pi-angle-left"}`}
            ></i>
          </div>
          {/* <p
            className="mb-0 text-start ps-2 fw-600 text-uppercase"
            style={{ color: "#002133" }}
          >
            UseSights Panel
          </p> */}
          {/* hide client name in left side on the header */}
          <p
            className="mb-0 text-start ps-2 fw-600 text-capitalize"
            style={{ color: "#002133" }}
          >
            {user && user.client_name}
          </p>
        </div>
        {/* <div className="text-center">
          <Button
            className={`fw-bold btn mx-2 ${
              selectePanelProject === PROJECT_PANEL.SMART_PANEL
                ? "active-button br-c"
                : "light-bg br-c"
            }`}
            onClick={() => setSelectedPanelProject(PROJECT_PANEL.SMART_PANEL)}
            label={`UseSights Panel`}
          />
          <Button
            className={`fw-bold btn me-2 ${
              selectePanelProject === PROJECT_PANEL.TEST_PANEL
                ? "active-button br-c"
                : "light-bg br-c"
            }`}
            onClick={() => setSelectedPanelProject(PROJECT_PANEL.TEST_PANEL)}
            label={`Test Panel`}
          />
        </div> */}
        <div className="d-flex align-items-center gap-2" id="logout_section">
          <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
            Welcome {user && user.firstname ? user.firstname : "User"}
          </span>

          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={(e) => op.current.toggle(e)}
          >
            <Avatar
              icon="pi pi-user"
              shape="circle"
              style={{
                backgroundColor: "#9c27b0",
                color: "#ffffff",
                cursor: "pointer",
              }}
            />
            <i className="pi pi-chevron-down ms-1 fs-12 fw-600"></i>
          </div>

          <OverlayPanel ref={op} className="custom-overlay-panel">
            <div
              className="p-2"
              onClick={() => setShowChangePwdModal(!showChangePwdModal)}
              style={{ cursor: "pointer" }}
            >
              Change Password
            </div>
            <div
              className="p-2"
              onClick={logout} // ✅ Correctly invokes logout
              style={{ cursor: "pointer" }}
            >
              Logout
            </div>
          </OverlayPanel>
        </div>
      </div>

      {/* Second Header */}
      {/* <div
        className={`d-flex flex-column flex-md-row py-2 border-bottom position-fixed second-header w-100 ${!showSidebar ? "hide-sidebar" : ""}`}
      >
        <div className="flex-grow-1 ms-4 text-start flex-wrap mb-2 mb-md-0">
          <div
            className={`me-2 me-md-3 ${
              location.pathname === "/dashboard" ? "active-button" : ""
            } br-c`}
            label="Dashboard"
            // style={{ padding: "0.5rem 1rem" }}
          />
        </div>
      </div> */}
      {/* Second Header */}
      <div
        style={{ marginTop: "65px", backgroundColor: "#fff" }}
        className={`d-flex flex-column flex-md-row py-2 border-bottom ${!showSidebar ? "hide-sidebar" : ""}`}
      >
        <div className="flex-grow-1 ms-3 text-start flex-wrap mb-2 mb-md-0">
          <Button
            outlined
            className={`me-md-3 br-c`}
            label={subHeaderText ? subHeaderText : "Dashboard"}
            style={{
              cursor: "default",
              fontSize: "18px",
              padding: "0.5rem 0rem",
            }}
          />
        </div>
        {!window.location.pathname.includes("/dashboard/survey") &&
          !window.location.pathname.includes("/dashboard/users") &&
          !window.location.pathname.includes("/dashboard/other-activities") && (
            <div className="flex-grow-1 ms-2 me-3 text-end d-flex align-items-center justify-content-end flex-wrap mb-2 mb-md-0">
              <i
                className="pi pi-calendar"
                style={{ fontSize: "18px", color: "#9e9e9e" }}
              />
              <div
                className="ms-1"
                style={{ color: "#9e9e9e", fontWeight: 600 }}
              >
                Date Range:
              </div>
              <div className="dropdown bt-dropdown">
                <Button
                  className="px-2 dropdown-toggle"
                  label={
                    dateRangeOptions.some(
                      (dateRange) => dateRange.value === filter_week,
                    )
                      ? dateRangeOptions.find(
                          (dateRange) => dateRange.value === filter_week,
                        )?.range
                      : `Set Date Range`
                  }
                  severity="info"
                  text
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />
                <ul className="dropdown-menu" style={{ zIndex: "9999" }}>
                  {dateRangeOptions.map((dateRange, index) => (
                    <li key={index}>
                      <div
                        className={`cursor-pointer dropdown-item py-2 ${dateRange.value === filter_week ? "active" : ""}`}
                        onClick={() =>
                          dispatch({
                            type: SAVE_DATE_RANGE,
                            payload: dateRange.value,
                          })
                        }
                      >
                        {dateRange.range}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              {end_date ? (
                <>
                  <div
                    className="mx-1"
                    style={{ color: "#9e9e9e", fontWeight: 600 }}
                  >
                    |
                  </div>

                  <div
                    className="ms-1"
                    style={{ color: "#9e9e9e", fontWeight: 600 }}
                  >
                    Ending Date: <span className="text_dark">{end_date}</span>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          )}
      </div>

      {showChangePwdModal ? (
        <ChangePasswordModal
          showChangePwdModal={showChangePwdModal}
          setShowChangePwdModal={setShowChangePwdModal}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Header;
